import { render, staticRenderFns } from "./BankHolid.vue?vue&type=template&id=2986a7b2&scoped=true"
import script from "./BankHolid.vue?vue&type=script&lang=js"
export * from "./BankHolid.vue?vue&type=script&lang=js"
import style0 from "./BankHolid.vue?vue&type=style&index=0&id=2986a7b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986a7b2",
  null
  
)

export default component.exports